var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotApplicable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00332 18L18.9264 5.07696M12.4648 21.5385C17.9878 21.5385 22.4648 17.0615 22.4648 11.5385C22.4648 6.01551 17.9878 1.53851 12.4648 1.53851C6.94184 1.53851 2.46484 6.01551 2.46484 11.5385C2.46484 17.0615 6.94184 21.5385 12.4648 21.5385Z",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotApplicable);
export default __webpack_public_path__ + "static/media/not_applicable.85388ea4c71c8cebdb7c09e6d0385a38.svg";
export { ForwardRef as ReactComponent };